import * as React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import LoadingFullScreen from "../../../components/LoadingFullScreen";
import { RootState, NavigationStep, Page } from "../../types";
import Overview from "../components/Overview";
import "./DashboardContainer.scss";
import {
  getLocations,
  getPatientList,
  getMorePatients,
  setLocation,
  setShowInactive,
  setSearchString
} from "../actions";
import { setPatientAndAct, deactivatePatient } from "../../patient/actions";
import { User } from "../../session/types";
import { Organization } from "../../organizations/types";
import DashboardActions from "../components/DashboardActions";
import { Patient } from "../../patient/types";

interface StoreProps {
  loading: boolean;
  passiveLoading: boolean;
  user: User | null;
  patientList: Page<Patient>;
  searchString: string;
  selectedPatient: Patient | null;
  showInactive: boolean;
  selectedLocation: string;
  locations: string[];
  orgs: Organization[] | null;
  selectedOrganization: Organization | null;
}

interface DispatchProps {
  deactivatePatient: (patient: Patient) => void;
  getPatientList: () => void;
  getMorePatients: () => void;
  setPatientAndAct: (patient: Patient, step: NavigationStep) => void;
  setSearchString: (searchString: string) => void;
  setShowInactive: (showInactive: boolean) => void;
  getLocations: () => void;
  setLocation: (searchString: string) => void;
}

type Props = DispatchProps & StoreProps & RouteComponentProps;

class DashboardContainer extends React.PureComponent<Props> {
  public render() {
    const { loading, passiveLoading } = this.props;

    if (loading) {
      return <LoadingFullScreen />;
    }

    return (
      <>
        <div className="dashboard width-restrict">
          <DashboardActions
            orgs={this.props.orgs}
            selectedOrganization={this.props.selectedOrganization}
            user={this.props.user}
          />
          <div className="sections">
            <Overview
              orgs={this.props.orgs}
              selectedOrganization={this.props.selectedOrganization}
              deactivatePatient={this.props.deactivatePatient}
              getPatientList={this.props.getPatientList}
              patientList={this.props.patientList}
              searchString={this.props.searchString}
              user={this.props.user}
              setPatientAndAct={this.props.setPatientAndAct}
              selectedPatient={this.props.selectedPatient}
              getMorePatients={this.props.getMorePatients}
              showInactive={this.props.showInactive}
              setSearchString={this.props.setSearchString}
              setShowInactive={this.props.setShowInactive}
              getLocations={this.props.getLocations}
              selectedLocation={this.props.selectedLocation}
              setLocation={this.props.setLocation}
              locations={this.props.locations}
              passiveLoading={this.props.passiveLoading}
            />
          </div>
          {loading && <LoadingFullScreen />}
          {passiveLoading && <LoadingFullScreen css="passive" />}
        </div>
      </>
    );
  }
}

export default connect<StoreProps, DispatchProps, {}, RootState>(
  state => ({
    loading: state.dashboard.loading,
    passiveLoading: state.dashboard.passsiveLoading,
    user: state.session.data.currentUser,
    patientList: state.dashboard.data.patientList,
    searchString: state.dashboard.data.searchString,
    selectedPatient: state.dashboard.data.selectedPatient,
    showInactive: state.dashboard.data.showInactive,
    locations: state.dashboard.data.locations,
    selectedLocation: state.dashboard.data.selectedLocation,
    orgs: state.orgs.data,
    selectedOrganization: state.orgs.currentOrganization
  }),
  {
    deactivatePatient,
    getLocations,
    getPatientList,
    getMorePatients,
    setLocation,
    setPatientAndAct,
    setSearchString,
    setShowInactive
  }
)(DashboardContainer);
